export const PARAGLIDE_CONTEXT_KEY = "$paraglide-adapter-sveltekit:context";
export const NO_TRANSLATE_ATTRIBUTE = "data-no-translate";
/** The path suffix SvelteKit adds on Data requests */
export const DATA_SUFFIX = "__data.json";
export const HTML_DATA_SUFFIX = ".html__data.json";
/** The key with which `invalidate` is called when the language changes */
export const LANGUAGE_CHANGE_INVALIDATION_KEY = "paraglide:lang";
